import Comment from './comment';
import ShareComment from './shareComment';

export { Comment, ShareComment };
